export const FeedbackStepEnum = {
  FOUND_INACCURACY: 0,
  FEEDBACK_LIST: 1,
  THANK_YOU: 2
}
